import actions from "./actions";
import endpoints from "../api/endpoints";

const {
  doVideoProductsRequest,
  doVideoProductsSuccess,
  doVideoProductsFailure,
} = actions;

const fetchVideoProducts = (videoId) => (dispatch) => {
  dispatch(doVideoProductsRequest());
  $.ajax({
    method: "get",
    url: endpoints.videoProducts.replace("{{videoId}}", videoId),
    success(data, statusText, { status }) {
      dispatch(doVideoProductsSuccess({ data, statusText, status }));
    },
    error(xhr) {
      dispatch(doVideoProductsFailure(xhr));
    },
  });
};

export default {
  fetchVideoProducts,
};
